import Activity from '@/models/Activity';
import { Question } from '@/models/Question';

export const adapterActivityQuestionOrder = (
  parents: Activity[],
  children: Record<string, Question[]>,
) => {
  const order = parents.map(activity => ({
    id: activity.id,
    questions: (children[String(activity.id)] ?? []).map(q => ({
      id: q.id,
      identifier: q.identifier,
      type: q.type,
    })),
  }));
  return order;
};
